const V2Day2Part2StartingDialog = {
    startDialogId: 'op1',
    nodes: {
        op1: {
            id: 'op1',
            speaker: 'Romo Darius',
            text: `Saya datang kesini karena mendengar keributan. Ada apa?`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op2"
        },
        op2: {
            id: 'op1',
            speaker: '',
            text: ``,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/desa.png',
            choices: [
                {
                    text: 'Kami menemukan Diana meninggal di kamar.',
                    nextDialogId: 'op3',
                },
                {
                    text: 'Diana sudah meninggal...',
                    nextDialogId: 'op3',
                },
            ],
        },
        op3: {
            id: 'op3',
            speaker: 'Nenek',
            text: `Apa yang terjadi dengan Diana?`,
            characterImage: '/assets/character/v2/nenek.png',//TODO nenek keriput ilang
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op4"
        },
        op4: {
            id: 'op4',
            speaker: 'Nenek',
            text: `Elsa! Apa yang terjadi? `,
            characterImage: '/assets/character/v2/nenek.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op5"
        },
        op5: {
            id: 'op4',
            speaker: 'Nenek',
            text: `Bukannya kamu satu kamar dengan Diana?`,
            characterImage: '/assets/character/v2/nenek.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op6"
        },
        op6: {
            id: 'op6',
            speaker: 'Elsa',
            text: `Aku sedang di toilet saat ini terjadi. Aku sumpah`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op7"
        },
        op7: {
            id: 'op',
            speaker: 'Elsa',
            text: `Aku tidak melakukan apa-apa!`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op8"
        },
        op8: {
            id: 'op',
            speaker: 'Ato',
            text: `Jangan bohong kamu. Sudah banyak kejadian dari kemarin.`,
            characterImage: '/assets/character/v2/ato.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op9"
        },
        op9: {
            id: 'op',
            speaker: 'Ato',
            text: `Ayo tangkap dia!`,
            characterImage: '/assets/character/v2/ato.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op10"
        },
        op10: {
            id: 'op10',
            speaker: 'Romo Darius',
            text: `Cukup Ato!`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op11"
        },
        op11: {
            id: 'op10',
            speaker: 'Romo Darius',
            text: `Di saat seperti ini, kita harus saling membantu.`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op12"
        },
        op12: {
            id: 'op10',
            speaker: 'Romo Darius',
            text: `Bantu bawakan Diana ke gereja agar bisa cepat kita doakan.`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op13"
        },
        op13: {
            id: 'op12',
            speaker: 'Ato',
            text: `Maaf Romo, baiklah`,
            characterImage: '/assets/character/v2/ato.png',
            backgroundImage: '/assets/backdrop/desa.png',
            nextDialogId : "op14"
        },
        op14: {
            id: 'op14',
            speaker: 'Romo Darius',
            text: `Nenek, dan Yan, mari kita bertemu di Gereja, dan doakan Diana bersama.`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/desa.png',
            isEnd : true
        },
    },
}

export default V2Day2Part2StartingDialog